import { SchemasRoot } from '../constants';

export enum ModuleSchemaId {
  LATEST = `${SchemasRoot}/modules/1.0.0.json`,
}
